import { Typography } from '@packages/uiKit/Typography';
import styled from 'styled-components';

export const StyledDateCell = styled(Typography)``;
